import * as angular from "angular";
import {IController} from "angular";

export class CustomerLinkComponent implements IController {

  customer: any;
  address: any;
  phone: string;
  additionalPhone: string;

  constructor() {}

  $onInit() {

  }


}

angular
  .module('bringoz.admin.customers')
  .component('customerLink', {
    bindings: {
      customer: '<',
      address: '<?',
      phone: '<?',
      additionalPhone: '<?'
    },
    template: require('./customer-link.html').default,
    controller: CustomerLinkComponent
  });



